
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"16","viewBox":"0 0 20 12"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#4A4A4A","fill-rule":"evenodd","d":"M0 0h20v2.191H0V0zm0 7.591V5.452h20v2.14H0zm0 5.452v-2.19h20v2.19H0z"}})])
          )
        }
      }
    